import { useEffect, useState } from 'react'
import { loadPublicConfig } from '../api/publicConfig.js'

export function usePublicConfig() {
  const [features, setFeatures] = useState(null)
  useEffect(() => {
    let live = true
    loadPublicConfig().then(f => {
      if (live) setFeatures(f)
    })
    return () => {
      live = false
    }
  }, [])
  return features
}
